import Menu from 'Models/Menu';

export default [
  // Menu.assetInformation,
  Menu.assetChemicalEdit,
  Menu.assetChemicalDelete,
  Menu.assetsHelp,
];
